import React, { useEffect, useState } from 'react'
import { InputNumber } from 'components'
import { ColumnExtended } from '@evrekadev/evreka-ui-components'
import { useTranslation } from 'utils/useTranslation'

type NumberColumnFilterProps = {
  column: ColumnExtended<any>
  filterValue: string | string[] | [string, string]
  onChange: (id: string, value: string | string[]) => void
  type: string
}

export function NumberColumnFilter({
  column: { id },
  onChange,
  filterValue,
}: NumberColumnFilterProps) {
  const { t } = useTranslation()
  const [value, setValue] = useState(filterValue || '')

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === '') {
      setValue('')
    } else {
      setValue(event.target.value)
    }
    onChange && onChange(id, event.target.value)
  }

  // ensure that reset loads the new value
  useEffect(() => {
    setValue(filterValue || '')
  }, [filterValue])

  return (
    <InputNumber
      placeholder={t('placeholder.default.search')}
      onChange={handleChange}
      componentSize="sm"
      value={value}
      clearButton={!!value}
    />
  )
}
